import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.036 12.379a1 1 0 0 0-1.415-1.415L14.5 13.087l-2.121-2.122a1 1 0 1 0-1.415 1.415l2.122 2.12-2.122 2.122a1 1 0 0 0 1.415 1.415l2.121-2.122 2.121 2.121a1 1 0 1 0 1.415-1.414L15.914 14.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 14.5C3 8.149 8.149 3 14.5 3S26 8.149 26 14.5c0 2.816-1.012 5.395-2.692 7.394l5.4 5.399a1 1 0 0 1-1.415 1.414l-5.399-5.399c-2 1.68-4.578 2.692-7.394 2.692C8.149 26 3 20.851 3 14.5M14.5 5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconMagnifyingGlassX = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMagnifyingGlassX);
export default Memo;
